import { render, staticRenderFns } from "./uiMultiple.vue?vue&type=template&id=8ef79e54"
import script from "./uiMultiple.vue?vue&type=script&lang=js"
export * from "./uiMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports